<template>
    <div>
        <!-- 1 line -->
        <div>
            <span class="mr-1">{{ $t(`org.footer.${VUE_APP_NAMESPACE}.MEGAZONE`) }} </span>
            <span class="mr-1">{{ $t(`org.footer.${VUE_APP_NAMESPACE}.Business Registration No`) }} </span>
            <span class="mr-1">{{ $t(`org.footer.${VUE_APP_NAMESPACE}.CEO`) }} </span>
            <b-link :to="{name:'privacy'}" style="vertical-align:text-bottom">{{ $t(`org.footer.${VUE_APP_NAMESPACE}.Privacy Notice`) }}</b-link>
        </div>
        <!-- 2 line -->
        <div>
            <span class="mr-1">{{ $t(`org.footer.${VUE_APP_NAMESPACE}.MEGAZONE B/D, 46, Nonhyeon-ro 85-gil, Gangnam-gu, Seoul, South Korea`) }} </span>
            <span class="mr-1">{{ $t(`org.footer.${VUE_APP_NAMESPACE}.Contact Call`) }} </span>
            <span>{{ $t(`org.footer.${VUE_APP_NAMESPACE}.Contact Email`) }}</span>
        </div>
        <!-- 3 line -->
        <div>
            <span style="font-style:italic">{{ $t(`org.footer.${VUE_APP_NAMESPACE}.Copyright`) }}</span>
        </div>
    </div>
    <!-- <b-card class="mb-0 w-100 text-center" :style="`background-color:${footerBgColor};color:${footerTextColor}`">
    </b-card> -->
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { ref, watch } from '@vue/composition-api'
export default {
    setup (props, context) {
        const VUE_APP_NAMESPACE = process.env.VUE_APP_NAMESPACE
        const { skin } = useAppConfig()
        const footerBgColor = ref('#fff')
        const footerTextColor = ref('#6e6b7b')
        if (localStorage.getItem('vuexy-skin') === 'dark') {
            footerBgColor.value = '#283046'
            footerTextColor.value = '#b4b7bd'
        }
        watch(skin, (value) => {
            if (value === 'light') {
                footerBgColor.value = '#fff'
                footerTextColor.value = '#6e6b7b'
            } else {
                footerBgColor.value = '#283046'
                footerTextColor.value = '#b4b7bd'
            }
        })
        return {
            VUE_APP_NAMESPACE,
            skin,
            footerBgColor,
            footerTextColor
        }
    }
}
</script>
